export let globalObject = {
    firstName: '',
    lastName: '',
    companyName: '',
    emailAddress: '',
    mobileNumber: '',
};